import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  value: {
    display: 'block',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: 1.4,
  },
}));

const TextCell = ({ value }) => {
  const classes = useStyles();

  if (!value) {
    return value;
  }

  return (
    <Tooltip title={value} placement="top" arrow>
      <span className={classes.value}>{value}</span>
    </Tooltip>
  );
};

TextCell.propTypes = {
  value: PropTypes.string,
};

TextCell.defaultProps = {
  value: '',
};

export default TextCell;
